<template>
  <v-card outlined>
    <v-card-title class="justify-center">
      {{ title }}
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="d-flex justify-center">
      <GChart type="PieChart" :data="data" :options="options"></GChart>
    </v-card-text>
    <template v-if="show_alert">
      <v-divider></v-divider>
      <v-card-text>
        <v-alert class="mb-0" type="info">
          {{ alert }}
        </v-alert>
      </v-card-text>
    </template>
    <v-divider></v-divider>
    <v-card-actions class="justify-center py-4" v-show="!hide_legend">
      <v-chip class="mx-2" :color="options.colors[0]" @click="show_responses('Bad')" label dark>
        Bad
      </v-chip>
      <v-chip class="mx-2" :color="options.colors[1]" @click="show_responses('Ok')" label dark>
        Ok
      </v-chip>
      <v-chip class="mx-2" :color="options.colors[2]" @click="show_responses('Good')" label dark>
        Good
      </v-chip>
    </v-card-actions>
    
    <v-divider v-if="clickable"></v-divider>
    <v-card-actions class="justify-center" v-if="clickable">
      <span class="text-caption">
        Click the buttons above to see your responses.
      </span>
    </v-card-actions>

    <v-divider v-if="shareable"></v-divider>
    <v-card-actions class="justify-center" v-if="shareable">
      <v-btn color="secondary" v-if="shareable" @click="share_dialog = true">
        Share
      </v-btn>
    </v-card-actions>

    <!-- Response Dialog -->
    <v-dialog v-model="response_dialog" max-width="500px">
      <v-card>
        <v-card-title class="justify-center">
          {{ response_type }} Responses
        </v-card-title>
        <v-card-subtitle class="text-center pb-4">
          {{ title }}
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <template v-for="(response, index) in responses_list">
            <v-card class="mb-4" :color="color_from_type(response_type)" :key="'response-' + index" dark>
              <v-card-title class="">
                {{response.question}}
              </v-card-title>
            </v-card>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Share Dialog -->
    <v-dialog v-model="share_dialog" max-width="600px">
      <v-card>
        <v-card-title>
          Share Link
        </v-card-title>
        <v-card-subtitle>
          Share your results with the link below.
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea
            class="mt-6 mb-1"
            v-model="share_url"
            outlined
            readonly
            dense
            hide-details
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-btn color="primary" @click="copy_share_url">
            Copy
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="share_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import LZString from 'lz-string';

  export default {
    name: 'pie-chart',
    props: ['title', 'data', 'clickable', 'responses', 'alert', 'show_alert', 'hide_legend', 'shareable'],
    data: function() {
      return {
        options: {
          width: '380',
          height: '380',
          legend: 'none',
          colors: ['#EF5350', '#66BB6A', '#42A5F5', '#AAAAAA'],
          chartArea: {
            left: '2%',
            top: '2%',
            width: '96%',
            height: '96%'
          }
        },

        response_dialog: false,
        response_type: 'Bad',
        responses_list: [],

        share_dialog: false,
      }
    },
    computed: {
      share_url: function() {
        const query_json = JSON.stringify({
          title: this.title,
          data: this.data
        });

        const query_lz = LZString.compressToEncodedURIComponent(query_json);
        return 'https://mylifepie.com/share-pie?pie=' + query_lz;
      },
    },
    methods: {
      color_from_type: function(type) {
        if (type === 'Bad') {
          return '#EF5350';
        }
        else if (type == 'Ok') {
          return '#66BB6A';
        }
        else {
          return '#42A5F5';
        }
      },

      show_responses: function(type) {
        if (!this.clickable) return;
        this.response_type = type;
        this.filter_responses(type);
        this.response_dialog = this.responses_list.length != 0;
      },

      copy_share_url: function() {
        navigator.clipboard.writeText(this.share_url);
      },

      utf_to_bin: function(str) {
        const codeUnits = new Uint16Array(str.length);
        for (let i = 0; i < codeUnits.length; i++) {
          codeUnits[i] = str.charCodeAt(i);
        }

        const charCodes = new Uint8Array(codeUnits.buffer);
        let result = '';
        for (let i = 0; i < charCodes.byteLength; i++) {
          result += String.fromCharCode(charCodes[i]);
        }
        return result;
      },

      filter_responses: function(type) {
        this.responses_list = this.responses.filter(r => r.response == type);
      }
    }
  }
</script>